import { status } from 'constants/general';
import { initialOrdersState } from 'redux/initialStates';
import ordersActionTypes from './action-types';

const ordersReducer = (state = initialOrdersState, { type, payload }) => {
  switch (type) {
    case ordersActionTypes.FETCH_ALL_ORDERS:
      return {
        ...state,
        ordersList: {
          status: status.FETCHING,
        },
      };

    case ordersActionTypes.FETCH_ALL_ORDERS_SUCCESS:
      return {
        ...state,
        ordersList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case ordersActionTypes.FETCH_ALL_ORDERS_FAIL:
      return {
        ...state,
        ordersList: {
          status: status.FAIL,
        },
      };

    case ordersActionTypes.FETCH_ORDER_DETAILS:
      return {
        ...state,
        orderDetails: {
          status: status.FETCHING,
        },
      };

    case ordersActionTypes.FETCH_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        orderDetails: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case ordersActionTypes.FETCH_ORDER_DETAILS_FAIL:
      return {
        ...state,
        orderDetails: {
          status: status.FAIL,
        },
      };

    case ordersActionTypes.SET_ORDER_DISPENSED_ITEMS_DETAILS:
      return {
        ...state,
        orderDispensedItems: payload,
      };

    case ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY:
      return {
        ...state,
        assignOrderToEntity: {
          status: status.FETCHING,
        },
      };

    case ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY_SUCCESS:
      return {
        ...state,
        assignOrderToEntity: {
          status: status.SUCCESS,
        },
      };

    case ordersActionTypes.FETCH_ASSIGN_ORDER_TO_ENTITY_FAIL:
      return {
        ...state,
        assignOrderToEntity: {
          status: status.FAIL,
        },
      };

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS: {
      return {
        ...state,
        orderServicesSuggestions: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS_SUCCESS: {
      return {
        ...state,
        orderServicesSuggestions: {
          status: status.SUCCESS,
          details: payload,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUGGESTIONS_FAIL: {
      return {
        ...state,
        orderServicesSuggestions: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.RESET_ORDER_SERVICES_SUGGESTIONS: {
      return {
        ...state,
        orderServicesSuggestions: {
          status: status.SHOULD_CALL_API,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION: {
      return {
        ...state,
        orderServicesSubmission: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION_SUCCESS: {
      return {
        ...state,
        orderServicesSubmission: {
          status: status.SUCCESS,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_SERVICES_SUBMISSION_FAIL: {
      return {
        ...state,
        orderServicesSubmission: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION: {
      return {
        ...state,
        orderStatusChangeSubmission: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION_SUCCESS: {
      return {
        ...state,
        orderStatusChangeSubmission: {
          status: status.SUCCESS,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_STATUS_CHANGE_SUBMISSION_FAIL: {
      return {
        ...state,
        orderStatusChangeSubmission: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION: {
      return {
        ...state,
        orderNoteChangeSubmission: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION_SUCCESS: {
      return {
        ...state,
        orderNoteChangeSubmission: {
          status: status.SUCCESS,
        },
      };
    }

    case ordersActionTypes.FETCH_ORDER_NOTE_CHANGE_SUBMISSION_FAIL: {
      return {
        ...state,
        orderNoteChangeSubmission: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION: {
      return {
        ...state,
        scheduleOrderSubmission: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION_SUCCESS: {
      return {
        ...state,
        scheduleOrderSubmission: {
          status: status.SUCCESS,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_SUBMISSION_FAIL: {
      return {
        ...state,
        scheduleOrderSubmission: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS: {
      return {
        ...state,
        scheduleOrderReasons: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS_SUCCESS: {
      return {
        ...state,
        scheduleOrderReasons: {
          status: status.SUCCESS,
          data: payload,
        },
      };
    }

    case ordersActionTypes.FETCH_SCHEDULE_ORDER_REASONS_FAIL: {
      return {
        ...state,
        scheduleOrderReasons: {
          status: status.FAIL,
        },
      };
    }

    case ordersActionTypes.FETCH_CANCEL_ORDER_REASONS: {
      return {
        ...state,
        cancelOrderReasons: {
          status: status.FETCHING,
        },
      };
    }

    case ordersActionTypes.FETCH_CANCEL_ORDER_REASONS_SUCCESS: {
      return {
        ...state,
        cancelOrderReasons: {
          status: status.SUCCESS,
          data: payload,
        },
      };
    }

    case ordersActionTypes.FETCH_CANCEL_ORDER_REASONS_FAIL: {
      return {
        ...state,
        cancelOrderReasons: {
          status: status.FAIL,
        },
      };
    }

    default:
      return state;
  }
};

export default ordersReducer;
